import { RouteObject } from "react-router";

export const NotesRoutes: RouteObject[] = [
  {
    path: "",
    async loader(args) {
      const { notesTabLoader } = await import("src/router/loaders/Jobs");
      return notesTabLoader(args);
    },
    async lazy() {
      const { NotesTab } = await import("jobs/Job/NotesTab");
      return { element: <NotesTab /> };
    },
    children: [
      {
        path: "new",
        async loader(args) {
          const { newNoteLoader } = await import("src/router/loaders/jobs/Notes");
          return newNoteLoader(args);
        },
        async lazy() {
          const { NoteForm } = await import("jobs/Job/NotesTab/NoteForm");
          return { element: <NoteForm /> };
        },
      },
      {
        path: ":noteId",
        async loader(args) {
          const { editNoteLoader } = await import("src/router/loaders/jobs/Notes");
          return editNoteLoader(args);
        },
      },
    ],
  },
];
